import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { ImageBlockDTO } from '@app/infrastructure/models/image-block';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-view-image-block',
  templateUrl: './view-image-block.component.html',
  styleUrls: ['./view-image-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewImageBlockComponent {
  @Input() imageBlock: ImageBlockDTO = new ImageBlockDTO();
}
